import { render, staticRenderFns } from "./OfficialAccount.vue?vue&type=template&id=7d62f9ed&scoped=true&"
import script from "./OfficialAccount.vue?vue&type=script&lang=js&"
export * from "./OfficialAccount.vue?vue&type=script&lang=js&"
import style0 from "./OfficialAccount.vue?vue&type=style&index=0&id=7d62f9ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62f9ed",
  null
  
)

export default component.exports